webpackJsonp([1],{

/***/ "/5P3":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("MFQs");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "3K5E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NotificationSuccess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css__ = __webpack_require__("/5P3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_common__ = __webpack_require__("2UA+");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var NotificationSuccess = function (_Component) {
  _inherits(NotificationSuccess, _Component);

  function NotificationSuccess() {
    _classCallCheck(this, NotificationSuccess);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  NotificationSuccess.prototype.render = function render(_ref) {
    var closeSuccessMsg = _ref.closeSuccessMsg,
        msg = _ref.msg;

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: '' + __WEBPACK_IMPORTED_MODULE_1__style_css___default.a.error },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { className: __WEBPACK_IMPORTED_MODULE_1__style_css___default.a.cross + ' left', src: __WEBPACK_IMPORTED_MODULE_2__common_common__["a" /* default */].getStaticPath() + '/assets/images/ic-check-cirlce.svg' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        null,
        msg
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { className: '' + __WEBPACK_IMPORTED_MODULE_1__style_css___default.a['close-box'], onClick: closeSuccessMsg },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { src: __WEBPACK_IMPORTED_MODULE_2__common_common__["a" /* default */].getStaticPath() + '/assets/images/ic-clear.svg', alt: '' })
      )
    );
  };

  return NotificationSuccess;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "MFQs":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, "._3UVG{min-height:48px;padding:12px 64px 12px 16px;font-size:14px;line-height:20px;-webkit-box-shadow:0 5px 13px rgba(0,0,0,.14);box-shadow:0 5px 13px rgba(0,0,0,.14);position:fixed;top:40px;left:50%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);margin:0 auto;z-index:99999;background:#fff;min-width:520px}._3DFn{margin-right:8px}._3UVG span{line-height:24px;display:inline-block}._21cf{position:absolute;right:0;top:0;width:48px;height:48px;border-left:1px solid #e6ebf3;text-align:center;padding-top:12px;cursor:pointer}@media(max-width:768px){._3UVG{min-width:90%;padding-left:40px}._3DFn{margin-right:8px;position:absolute;left:8px}._21cf{bottom:0;height:auto}}", ""]);

// exports
exports.locals = {
	"error": "_3UVG",
	"cross": "_3DFn",
	"close-box": "_21cf"
};

/***/ })

});


// WEBPACK FOOTER //
// 1.chunk.e134e.js